// Supabase 初期化（脱Firebase移行）。Vite(import.meta.env) と Node(process.env) 両対応。
// ブラウザは anon(publishable) キーのみ使用。Node実行(取込/検証)時は SUPABASE_SERVICE_ROLE をフォールバック。
import { createClient } from '@supabase/supabase-js'

const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : null
const env = viteEnv || (typeof process !== 'undefined' ? process.env : {})

const url = env.VITE_SUPABASE_URL || env.SUPABASE_URL
const key = env.VITE_SUPABASE_ANON_KEY || env.SUPABASE_ANON_KEY || env.SUPABASE_SERVICE_ROLE

// 許可アカウント。カンマ区切り。`@example.com` はドメイン一致、それ以外はアドレス完全一致（大小無視）。
// 旧 VITE_ALLOWED_DOMAIN（ドメインのみ）も後方互換で受ける。本番の鍵は Supabase RLS 側（下記は補助）。
function buildAllowList() {
  const emails = env.VITE_ALLOWED_EMAILS || env.ALLOWED_EMAILS
  if (emails) return String(emails).split(',').map(s => s.trim().toLowerCase()).filter(Boolean)
  const domain = env.VITE_ALLOWED_DOMAIN || env.ALLOWED_DOMAIN
  if (domain) return ['@' + String(domain).trim().toLowerCase().replace(/^@/, '')]
  return ['l.donky.l@gmail.com']
}
export const ALLOWED_EMAILS = buildAllowList()
export function isAllowedEmail(email) {
  const e = String(email || '').trim().toLowerCase()
  if (!e) return false
  return ALLOWED_EMAILS.some(a => (a.startsWith('@') ? e.endsWith(a) : e === a))
}
export const supabaseReady = Boolean(url && key)
export const supabase = supabaseReady
  ? createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } })
  : null
